import { createAction, props } from '@ngrx/store';
import { CxSalesLocation } from '../../models/sales-location';

export interface CxSalesLocationRequest {
  productTypeId: string | number;
}

export const resetState = createAction('[SALES_LOCATION] Reset State');
export const initEntity = createAction('[SALES_LOCATION] Init Entity', props<{ id: string }>());
export const resetEntityState = createAction('[SALES_LOCATION] Reset Entity', props<{ id: string }>());
export const fetchEntity = createAction('[SALES_LOCATION] Fetch Entity start', props<CxSalesLocationRequest>());
export const updateEntity = createAction('[SALES_LOCATION] Update Entity', props<{ payload: CxSalesLocation }>());
export const updateEntities = createAction('[SALES_LOCATION] Update Entities', props<{ payload: CxSalesLocation[] }>());
export const selectEntity = createAction('[SALES_LOCATION] Select Entity', props<{ id: string }>());

export const CxSalesLocationActions = {
  resetState,
  initEntity,
  resetEntityState,

  updateEntity,
  updateEntities,
  selectEntity,

  fetchEntity,
};

export default CxSalesLocationActions;
